import { useEffect, useState } from "react";
import './ChimeMeetControls.scss';
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationPopup from "../../ConfirmationPopup/ConfirmationPopup";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from "../../../utils/constants";
import images from "../../../assets/images";
import { useMutation } from "@apollo/client";
import { useGlobalState } from "../../../MeetContext/MeetContext";
import { END_THE_LIVE_SESSION, UPDATE_SESSION_PARTICIPANTS_COUNT } from "../../../pages/LiveClass/api/LiveClassQuery";
import { UPDATE_SESSION_WORKSHOP_PARTICIPANT_COUNT, UPDATE_WORKSHOP_ENDED, UPDATE_WORKSHOP_MEETING_ID } from "../../../pages/Workshop/api/WorkshopQuery";
import MaterialActionsOverlay, { MenuItemType } from "../../ActionsOverlay/MaterialActionsOverlay";
import { UPDATE_MEETING_PARTICIPANT_COUNT, UPDATE_MEETING_STATUS } from "../../../pages/AdminPta/api/PtaQuery";
import { isPlatform } from "@ionic/react";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ToasterWithMessage from "../../toaster";
import { useAttendeeStatus, useContentShareControls, useLocalVideo, useToggleLocalMute } from "amazon-chime-sdk-component-library-react";
import { useChimeMeeting } from "../../../Chime/ChimeMeetingContext";
import { UPDATE_SESSION_RECORD } from "../../../Chime/helpers/Api/ChimeApi";
import { setCurrentSessionRecordingDetail } from "../../../redux/slices/dashboardSlice";



const ChimeMeetControls = () => {
    const { setOpenShareScreenPopup, openShareScreenPopup, handleParticipantsGridViewToggle, toggleChat, toggleParticipant } = useGlobalState();
    const currentSessionId = useAppSelector((state) => state?.dashboard?.currentSessionId);
    const currentWorkshopId = useAppSelector((state) => state?.dashboard?.currentWorkshopId);
    const currentPtaMeetId = useAppSelector((state) => state?.dashboard?.currentPtaMeetId);
    const {state} = useLocation();
    const { role, loginpage } = useAppSelector((state) => state.auth);

    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [openOverlay, setOpenOverlay] = useState<boolean>(false);
    const [action, setAction] = useState<string>('');
    const [promptMessage, setPromptMessage] = useState<string>('');
    const {Crying, StopIconRed} = images;
    const {error} = ToasterWithMessage();
    const { MicOff, MicOn, VideoOn, VideoOff, EndCall, ScreenSharingIcon, HandOn, HandOff } = images;
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const meetComponent = useAppSelector((state) => state?.dashboard?.meetComponent);
    const navigate = useNavigate();
    const { toggleContentShare } = useContentShareControls();
    const { startRecordingInProgress, stopRecordingInProgress, startRecording, stopRecording, isRecording, leaveMeeting, endMeeting, attendeeId, toggleHandRaise , isHandRaised, isHost, hostId, userId} = useChimeMeeting();
    const dispatch = useAppDispatch();
    const { muted, toggleMute } = useToggleLocalMute();
    const { toggleVideo } = useLocalVideo();

    const {
        // muted,
        videoEnabled,
        sharingContent,
    } = useAttendeeStatus(attendeeId ? attendeeId : "");
    
    const [updateSessionRecord] = useMutation(UPDATE_SESSION_RECORD, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            // setIsRecording(true);
            // dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: data?.recordStartTime, recordingStarted: data?.isRecordStart}));
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    const [updateWorkshopSessionRecord] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            // setIsRecording(true);
            // dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: data?.recordStartTime, recordingStarted: data?.isRecordStart}));
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    const [updatePtaSessionRecord] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            // setIsRecording(true);
            // dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: data?.recordStartTime, recordingStarted: data?.isRecordStart}));
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    const [updateSessionParticipantCount] = useMutation(UPDATE_SESSION_PARTICIPANTS_COUNT, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {},
        onError: (err) => {
          console.log("errr while updating participant count",err?.message);
        }
    });

    const [updateWorkshopSessionParticipantCount] = useMutation(UPDATE_SESSION_WORKSHOP_PARTICIPANT_COUNT, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {},
        onError: (err) => {
            console.log("errr while updating participant count",err?.message);
        }
    });

    const [updateMeetParticipantCount] = useMutation(UPDATE_MEETING_PARTICIPANT_COUNT, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {},
        onError: (err) => {}
    });

    const [updateSessionEnd] = useMutation(END_THE_LIVE_SESSION, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {},
        onError: (err) => {}
    });

    const [updateWorkshopEnd] = useMutation(UPDATE_WORKSHOP_ENDED, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {},
        onError: (err) => {}
    });

    const [updatePtaEnd] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {},
        onError: (err) => {}
    });

    const handleUpdateParticipantCount = async () => {
        // if(meetComponent === 'liveclass'){
        //     await updateSessionParticipantCount({
        //         variables: {
        //           cId: selectedClassRoomId,
        //           sId: currentSessionId,
        //           sjId: selectedSubjectId,
        //           participanttype: false
        //         }
        //       })
        // }else if(meetComponent === 'workshop'){
        //     await updateWorkshopSessionParticipantCount({
        //         variables: {
        //             input: {
        //                 participantType: false,
        //                 wsId: currentWorkshopId
        //             }
        //         }
        //     })
        // }else if (meetComponent === 'pta') {
        //     await updateMeetParticipantCount({
        //         variables: {
        //             input: {
        //                 mId: currentPtaMeetId,
        //                 participantType: false
        //             }
        //         }
        //     })
        // }
    }



    const onYesButtonClick = async () => {
        handleUpdateParticipantCount();
        setOpenConfirmationPopup(false);
        if(action === 'leave'){
            try {
                await leaveMeeting();
            } catch (error) {
                console.error('Failed to leave meeting:', error);
                alert('An error occurred while leaving the meeting. Please try again.');
            }
        }else if(action === 'end'){
            try {
                await endMeeting();
                if(meetComponent === 'liveclass'){
                    updateSessionEnd({
                        variables:{
                        cId:selectedClassRoomId,
                        sId:currentSessionId,
                        sjId:selectedSubjectId
                        }
                    });
                }else if(meetComponent === 'workshop'){
                    updateWorkshopEnd({
                        variables:{
                            wsId:currentWorkshopId
                        }
                    });   
                }else if(meetComponent === 'pta'){
                    updatePtaEnd({
                        variables: {
                          updateInput: {
                            mStatus: "ENDED",
                          },
                          mId: currentPtaMeetId,
                        }
                      });   
                }
            } catch (error) {
                console.error('Failed to leave meeting:', error);
                alert('An error occurred while leaving the meeting. Please try again.');
            }
        }
        toggleChat(false);
        toggleParticipant(false);
        handleParticipantsGridViewToggle(false);
        if(isHost && isRecording){
        const recordingStartTime = new Date().toISOString();
            if (meetComponent === 'liveclass') {
                updateSessionRecord({
                    variables: {
                        cId: selectedClassRoomId,
                        sId: currentSessionId,
                        sjId: selectedSubjectId,
                        isRecordStart: false,
                        recordStarttime: recordingStartTime
                    }
                });
            } else if (meetComponent === 'workshop') {
                updateWorkshopSessionRecord({
                    variables: {
                        updateInput: {
                            isRecordStart: false,
                            recordStartTime: recordingStartTime
                        },
                        wsId: currentWorkshopId
                    }
                });
            } else if (meetComponent === 'pta') {
                updatePtaSessionRecord({
                    variables: {
                        updateInput: {
                            isRecordStart: false,
                            recordStartTime: recordingStartTime
                          },
                          mId: currentPtaMeetId,
                    }
                });
            } else {
                console.log('meet component', meetComponent);
            }
        dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: recordingStartTime, recordingStarted: false}));
             }
        if(role === STUDENT_ROLE){
            navigate('/student-classroom/liveclass',{state:state});
        }else if(role === TEACHER_ROLE && meetComponent === 'liveclass'){
            navigate('/teacher-classroom/liveclass',{state:state});
        }else if(role === TEACHER_ROLE && meetComponent === 'workshop'){
            navigate('/teacher-workshop');
        }else if(role === TEACHER_ROLE && meetComponent === 'pta'){
            navigate('/teacher-pta', {
                state: state
              });
        }else if(((role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN)) && meetComponent === 'pta'){
            navigate('/admin-pta/meetings', {
                state: state
              });
        }else if(((role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN)) && meetComponent === 'workshop'){
            navigate('/admin-workshop');
        }else if(role === PTA_ROLE) {
            navigate('/pta-meetings', {
                state: state
              });
        }
    };

    const onNoButtonClick = () => {
        setOpenConfirmationPopup(false);
        setAction('');
        setPromptMessage('');
    };

    useEffect(() => {
        window.addEventListener("beforeunload", () => {
                handleUpdateParticipantCount();
        });
        window.addEventListener("popstate", () => {
                handleUpdateParticipantCount();
        });

        return () => {
            // Clean up the event listeners when the component unmounts
            window.removeEventListener('beforeunload', handleUpdateParticipantCount);
            window.removeEventListener('popstate', handleUpdateParticipantCount);
        };
    },[]);
    
    // useEffect(()=>{
    //     if(currentSessionRecordingDetail?.recordingStarted === true){
    //         setIsRecording(true);
    //     }
    // },[currentSessionRecordingDetail?.recordingStarted]);

    const handleClickEndButton = (event:  React.MouseEvent<HTMLElement>) => {
        if(((role === TEACHER_ROLE) && (meetComponent === 'liveclass'))){
            // setOpenOverlay(true);
            // setAnchorEl(event.currentTarget);
            setPromptMessage("Are you sure you want to End this Session?");
            setOpenConfirmationPopup(true);
            setAction('end');
        }else if((role === SCHOOL_ADMIN) && (meetComponent === 'workshop')){
            // setOpenOverlay(true);
            // setAnchorEl(event.currentTarget);
            setPromptMessage("Are you sure you want to End this Session?");
            setOpenConfirmationPopup(true);
            setAction('end');
        }else if((((role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN))) && (meetComponent === 'pta')){
            // setOpenOverlay(true);
            // setAnchorEl(event.currentTarget);
            setPromptMessage("Are you sure you want to End this Session?");
            setOpenConfirmationPopup(true);
            setAction('end');
        }else {
            setPromptMessage("Are you sure you want to Leave this Session?");
            setOpenConfirmationPopup(true);
            setAction('leave');
        }
    }

    const handleCloseActions = () => {
        setAnchorEl(null);
        setOpenOverlay(false);
    };

      const menuItems: MenuItemType[] = [
        {
          label: "Leave",
          onClick: () => {
            setAction("leave");
            setPromptMessage("Are you sure you want to Leave this Session?");
            setOpenConfirmationPopup(true);
            handleCloseActions();
          }
        },
        {
          label: "End meeting",
          onClick: () => {
            setAction("end");
            setPromptMessage("Are you sure you want to End this Session?");
            setOpenConfirmationPopup(true);
            handleCloseActions();
          }
        }
    ];

    const handleStartRecording = () => {
        console.log('inside handleStartRecording=========>')
        if (isRecording) {
            error("The meeting is already being recorded.");
        } else {
            const recordingStartTime = new Date().toISOString();
            startRecording(recordingStartTime);
                if (meetComponent === 'liveclass') {
                    updateSessionRecord({
                        variables:{
                            cId: selectedClassRoomId,
                            sId: currentSessionId,
                            sjId: selectedSubjectId,
                            isRecordStart: true,
                            recordStarttime: recordingStartTime
                        }
                    });
                } else if (meetComponent === 'workshop') {
                    updateWorkshopSessionRecord({
                        variables: {
                            updateInput: {
                                isRecordStart: true,
                                recordStartTime: recordingStartTime
                            },
                            wsId: currentWorkshopId
                        }
                    });
                } else if (meetComponent === 'pta') {
                    updatePtaSessionRecord({
                        variables:{
                            updateInput: {
                                isRecordStart: true,
                                recordStartTime: recordingStartTime
                              },
                              mId: currentPtaMeetId,
                        }
                    });
                } else {
                    console.log('meet component', meetComponent);
                }
                dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: recordingStartTime, recordingStarted: true}));

                }
    };

    const handleStopRecording = () => {
        const recordingStopTime = new Date().toISOString();
        // setRecordingStartTime(null);
        stopRecording();
        if (meetComponent === 'liveclass') {
            updateSessionRecord({
                variables:{
                  cId: selectedClassRoomId,
                  sId: currentSessionId,
                  sjId: selectedSubjectId,
                  isRecordStart: false,
                  recordStarttime: recordingStopTime
                }
            });
        } else if (meetComponent === 'workshop') {
            updateWorkshopSessionRecord({
                variables:{
                    updateInput: {
                        isRecordStart: false,
                        recordStartTime: recordingStopTime
                    },
                    wsId: currentWorkshopId
                }
            });
        } else if (meetComponent === 'pta') {
            updatePtaSessionRecord({
                variables:{
                    updateInput: {
                        isRecordStart: false,
                        recordStartTime: recordingStopTime
                      },
                      mId: currentPtaMeetId,
                }
            });
        } else {
            console.log('meet component', meetComponent);
        }
        dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: recordingStopTime, recordingStarted: false}));
    };

    // useEffect(() => {
    //     if(isMeetingEndByHost){
    //         handleUpdateParticipantCount();
    //     }
    // }, [isMeetingEndByHost])

    const handleShareScreen = () => {
        handleParticipantsGridViewToggle(false);
        if (window.electron && window.electron.isElectron() && !sharingContent) {
            setOpenShareScreenPopup(!openShareScreenPopup);
        }else{
            toggleContentShare();
        }
    }

    console.log('inside the meet control videoenabled',videoEnabled);

    return(
        <div className="meet-controls">
            <div className="meet-controls-main">
                {
                    (!sharingContent && (!isPlatform('android'))) && 
                    <div onClick={handleShareScreen} >
                        <img src={ ScreenSharingIcon } alt="screenshare" className="ScreenShareIcon" />
                    </div>  
                }
                {/* <VideoInputControl className={videoEnabled ? "videoEnabled" : "videoDisabled"} /> */}
                {  
                    videoEnabled ? 
                    <div onClick={ () => toggleVideo()}>
                        <img src={ VideoOn } alt="videoOn" className="videoOnIcon" />
                    </div> :
                    <div onClick={ () => toggleVideo()}>
                        <img src={ VideoOff } alt="videoOff" className="VideoIcon" />
                    </div> 
                }
                <div onClick={(e) => handleClickEndButton(e)} >
                    <img src={ EndCall } alt="videoOff" className="EndCallIcon" />
                </div>
                {
                    muted ? 
                    <div onClick={ () => toggleMute()}>
                        <img src={ MicOff } alt="videoOn" className="AudioIcon" />
                    </div> :
                    <div onClick={ () => toggleMute()}>
                        <img src={ MicOn } alt="videoOn" className="AudioOnIcon" />
                    </div> 
                }
                {/* <AudioInputControl /> */}
                {
                        isHandRaised ? 
                        <div onClick={ () => toggleHandRaise()}>
                            <img src={ HandOn } alt="videoOn" className="HandIcon" />
                        </div> :
                        <div onClick={ () => toggleHandRaise()} className="Hand">
                            <img src={ HandOff } alt="videoOn" className="HandOffIcon" />
                        </div>
                }
                {
                    ((isRecording) && (userId === hostId)) ? 
                    <div onClick={handleStopRecording} className={`recordIconContainer ${startRecordingInProgress || stopRecordingInProgress ? "button-disabled" : ""}`}>
                        <img src={StopIconRed} className="recordingStopIcon" alt="recording stop"/>
                    </div>
                    :
                    (userId === hostId) &&
                    <div onClick={handleStartRecording} className={`recordIconContainer ${startRecordingInProgress || stopRecordingInProgress ? "button-disabled" : ""}`}>
                        <RadioButtonCheckedIcon className="recordingStartIcon" sx={{
                            color: 'red',
                            height: '35px',
                            width: '35px'
                        }}/>
                    </div>
                }
            </div>
            <MaterialActionsOverlay
                anchorEl={anchorEl}
                open={openOverlay}
                handleClose={handleCloseActions}
                menuItems={menuItems}
                actionsHeight={'84px'}
                position="center"
                verticalPosition="top"  
                module ={`meetControls`}
            />
            <ConfirmationPopup
                open={openConfirmationPopup}
                message={promptMessage}
                gifData={Crying}
                yesButtonFunctionality={onYesButtonClick}
                noButtonFunctionality={onNoButtonClick}
                messageWidth={'264px'}
            />
        </div>
    )
}

export default ChimeMeetControls;
